import { postApiRailsServer, getApiRailsServer } from "services";
import { createTeamParams } from "GlobalModule/types";

export const createTeam = (params: createTeamParams, token: string) =>
  postApiRailsServer("/signup", params, {}, token);

export const getRecurlyPlan = (token: string) =>
  getApiRailsServer("/show_available_plans", {}, token);
